<div id="promo-wrapper">
    <section id="promo" class="mt-4 mb-4">
        <div class="container dark">

            <header>
                <h2 i18n>Das Unternehmen</h2>
            </header>

            <p i18n>Willkommen bei AlbCode, Ihrem verlässlichen IT-Partner im Herzen der Schwäbischen Alb. Am Rande von Hechingen, am Fuße der imposanten Burg
                Hohenzollern, verbinden wir technologische Expertise mit schwäbischem Qualitätsbewusstsein. Als kleines, aber hochspezialisiertes IT-Unternehmen sind wir stolz
                darauf, maßgeschneiderte Lösungen für Unternehmen in der Region und darüber hinaus zu bieten.</p>

            <p i18n>Unsere Schwerpunkte liegen in der Entwicklung von innovativen Softwarelösungen, IT-Beratung sowie der Betreuung von Netzwerken und IT-Infrastrukturen. Dabei liegt
                unser Fokus klar auf Kundenorientierung, um somit Technik und Mensch in Einklang zu bringen.</p>

            <p i18n>Wir hören zu, analysieren genau und entwickeln Lösungen, die passgenau auf Ihre Bedürfnisse zugeschnitten sind. Mit unserer Arbeit tragen wir dazu bei, die digitale
                Zukunft auch in unserer wunderschönen Region voranzutreiben.</p>

            <p i18n>AlbCode – Innovativ, verlässlich, bodenständig.</p>

            <div class="service-links">
                <a routerLink="/albcode/webportale" class="glow-on-hover p-3" i18n>Webportale entdecken</a>
                <a routerLink="/albcode/softwaremodernisierung" class="glow-on-hover p-3" i18n>Software modernisieren</a>
            </div>

        </div>
    </section>
</div>

<div class="wrapper pb-1">
    <section class="container">

        <div class="row features justify-content-center">
            <section class="col-12 col-12-mobile feature pb-0">

                <div class="image-wrapper row mt-3">
                    <div class="col-4 col-12-narrower p-0">
                        <div class="image featured m-0"><img id="agileimg" src="/images/team.jpg" alt="Agile Softwareentwicklung" i18n-alt /></div>
                    </div>
                    <div class="col-8 col-12-narrower align-self-center">
                        <header class="major">
                            <h2 i18n>Unser Team</h2>
                        </header>
                        <p i18n>Gemeinsam mit unserem gesamten Team bei AlbCode arbeiten wir daran, individuelle und zukunftssichere IT- und Softwarelösungen für unsere Kunden zu
                            entwickeln.</p>
                    </div>
                </div>

            </section>
        </div>
    </section>
</div>

<div class="wrapper">
    <section class="container ">

        <div class="row features team-members">
            <section class="col-4 col-12-narrower feature text-start ps-4">
                <header class="major">
                    <h2 i18n>Maik Saliger</h2>
                    <small i18n>B.Eng. Kommunikations- und Softwaretechnik</small>
                    <p class="pb-0 mb-0" i18n>Geschäftsführer, Softwareentwickler</p>
                </header>
                <div class="image-wrapper first">
                    <div class="image featured p-0"><img src="/images/MaikSaliger.jpeg" alt="Maik Saliger" i18n-alt /></div>
                </div>
                <p i18n>Maik Saliger bringt seine langjährige Erfahrung in jedes Projekt ein. Mit seiner Spezialisierung auf die Backend-Entwicklung –
                    insbesondere mit Java und dem Spring Framework – sorgt er für leistungsstarke und zuverlässige Systemarchitekturen. Als Projektmanager verbindet er technisches
                    Fachwissen mit organisatorischem Geschick. Er koordiniert das Teams und die Ressourcen, um Projekte
                    effizient und zielgerichtet voranzubringen. Dabei legt er großen Wert auf transparente Kommunikation und maßgeschneiderte Lösungen, die exakt auf die
                    Bedürfnisse der Kunden abgestimmt sind.</p>
            </section>
            <section class="col-4 col-12-narrower feature text-start ps-4">
                <header class="major">
                    <h2 i18n>Sandra Saliger</h2>
                    <small i18n>M.Sc. Bioinformatik</small>
                    <p class="pb-0 mb-0" i18n>Softwareentwicklerin, Buchhaltung</p>
                </header>
                <div class="image-wrapper">
                    <div class="image featured p-0"><img src="/images/SandraSaliger.jpeg" alt="Sandra Saliger" i18n-alt /></div>
                </div>
                <p i18n>Sandra Saliger ist Spezialistin für die Entwicklung moderner Webanwendungen. Dank ihres Master-Abschlusses und ihrer
                    Leidenschaft für innovative Technologien entwickelt sie maßgeschneiderte Softwarelösungen, die höchsten Ansprüchen gerecht werden. Ihre Fähigkeit, komplexe
                    Anforderungen in benutzerfreundliche Anwendungen zu übersetzen, ist ein entscheidender Vorteil für unsere Projekte. Zudem ist sie Ansprechpartnerin für alle
                    Themen rund um die Buchhaltung und Abrechnung, sowie Fragen zu Lexware Office.</p>
            </section>
            <section class="col-4 col-12-narrower feature text-start ps-4">
                <header class="major">
                    <h2 i18n>Alexander Ruf</h2>
                    <small i18n>&nbsp;</small>
                    <p class="pb-0 mb-0" i18n>IT-Systemadministrator<br>&nbsp;</p>
                </header>
                <div class="image-wrapper">
                    <div class="image featured p-0"><img src="/images/AlexanderRuf.jpeg" alt="Alexander Ruf" i18n-alt /></div>
                </div>
                <p i18n>Mit einem fundierten technischen Hintergrund sorgt Alexander Ruf dafür, dass alle IT-Infrastrukturen reibungslos funktionieren. Sein Know-how und seine präzise
                    Arbeitsweise machen ihn zu einem unverzichtbaren Teil unseres Teams. Ob Systemadministration, Netzwerkbetreuung oder technische Unterstützung – Alexander steht
                    unseren Kunden mit Kompetenz und Engagement zur Seite.</p>
            </section>
        </div>
    </section>
</div>
